import { Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import CommonFile from '../../assets/Common 2@2x.png'

interface IFacilityNotFoundPageProps {
  facility?: string
}
export const FacilityNotFoundPage: FC<IFacilityNotFoundPageProps> = ({ facility = 'facility' }) => {
  const { t } = useTranslation('common')
  return (
    <Stack justifyContent={'center'} alignItems={'center'} minHeight={'calc(100vh - 100px)'} width={'100%'}>
      <img src={CommonFile as string} height={'300px'} width={'300px'} />
      <Typography variant="h5" color={'primary'} style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
        {t('facility-not-found', { ns: 'common', facility: facility })}
      </Typography>
    </Stack>
  )
}
